const INTAKE_GROUPED_SEGMENT_PREVIEW_SCOPE = 'intake-grouped-segment-preview';

export const IntakeGroupedSegmentPreviewTestIds = {
  getPartId: partId => `${INTAKE_GROUPED_SEGMENT_PREVIEW_SCOPE}.part-${partId}`,
};
